import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CircularProgress, Typography } from '@mui/material';
import queryString from 'query-string';
import { verifySubmissionByToken } from 'actions/SubmissionActions';

export class EmailVerificationPage extends React.Component {
  componentDidMount() {
    const { promotion, location } = this.props;

    const params = queryString.parse(location.search);
    this.props.verifySubmissionByToken(promotion.id, params.token);
  }

  render() {
    return (
      <center>
        <CircularProgress />
        <Typography>Verifying...</Typography>
      </center>
    )
  }
}

const mapDispatchToProps = {
  verifySubmissionByToken: (promotionId, token) => verifySubmissionByToken(promotionId, token)
};

export default withRouter(connect(null, mapDispatchToProps)(EmailVerificationPage));
